import { createSelector } from 'reselect';
import type { RouteObject } from 'redux-first-router';
import type { LocationState } from 'redux-first-router';
import { ROUTE_HOME } from '@/constants/routes';
import { ViewMode } from '@/pages/CompanyReport/enum';

export const getLocation = (state): LocationState => state.location;

export const getPreviousLocation = createSelector(
  [getLocation],
  (location) => location.prev
);

export const getCurrentLocation = createSelector(
  [getLocation],
  (location) => location
);

export const getRouteFromPath = (redirectTo) =>
  createSelector([getLocation], (location) => {
    const { routesMap } = location;
    const entities = Object.entries(routesMap).filter(([key, routeObj]) => {
      const { path } = routeObj as RouteObject;
      if (redirectTo) {
        return path === redirectTo;
      } else if (key === ROUTE_HOME) {
        return true;
      }
    });
    const [firstEntry] = entities;
    const [path] = firstEntry;
    return path;
  });

export const getPathFromRoute = (route) =>
  createSelector([getLocation], (location) => {
    const { path } = location.routesMap[route] as { path: string };
    return path;
  });

export const getViewMode = createSelector(
  [getLocation],
  (location): ViewMode => {
    return location.query &&
      location.query.viewmode &&
      location.query.viewmode === ViewMode.Print
      ? ViewMode.Print
      : ViewMode.Screen;
  }
);

export const makeViewModeSelector = () => getViewMode;
